// extracted by mini-css-extract-plugin
export var divider = "_ol-0";
export var systemMessage = "_ol-1";